<template>
    <div class="careers-internship">
      <div class="careers-internship-content">
        <p class="indent">Alcomet offers considerable training and career opportunities for young professionals through a variety of student training programmes and individual scholarships.</p>
        <ul>
            <li class="strong underline">Company trainee programs</li>
        </ul>
        <p class="strong">Duration:</p>
        <ul>
            <li class="underline">1 month</li>
        </ul>
        <p class="strong">Conditions of company trainee programs:</p>
        <ul>
            <li>The program is suitable for Bachelor’s degree students, who passed their third course of education, students in their Master’s degree of education or recently graduated young specialists</li>
            <li>As a trainee in our company, you will receive the social benefits like a daily food allowance in the canteen and transportation to and from the workplace.</li>
        </ul>
        <p class="strong">Field of trainee programs:</p>
        <ul>
            <li>- Metallurgy</li>
            <li>- Engineering chemistry</li>
            <li>- Hydraulic and pneumatic technique</li>
            <li>- Instrumental equipment, machines and apparatus</li>
            <li>- Information technologies</li>
            <li>- Automatic management systems</li>
            <li>- Industrial management</li>
        </ul>
        <p class="strong"> How to apply:</p>
        <p class="indent">In case you are interested in applying for the company trainee programs, please, send us your CV with a cover letter describing your interests, ideas and plans for your future development and information about the chosen field of trainee programs at the following address:</p>
        <p class="no-margin">E-mail: <a href="mailto:hr@alcomet.eu">hr@alcomet.eu</a></p>
        <p class="no-margin">2nd Industrial Zone</p>
        <p class="no-margin">9700 Shumen</p>
        <p class="no-margin">Alcomet AD</p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.careers-internship-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.careers-internship-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.careers-internship-content > ul {
  list-style: disc;
  padding-left: 20px;
  width: 60%;
}
.careers-internship-content ul li {
  display: block;
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
}
.careers-internship-content .no-margin {
  margin: 0;
}
.careers-internship-content .underline {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .careers-internship-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .careers-internship-content > ul {
    padding-left: 50px;
    padding-right: 30px;
    width: 100%;
  }
  .careers-internship-content ul li {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/Internships.vue